import * as React from "react"
import Card from "@material-ui/core/Card"
import Box from "@material-ui/core/Box"
import Fade from "@material-ui/core/Fade"
/**
 * Components
 */
import CardTitle from "components/CardTitle"
import Loader from "components/Loader"
/**
 * Icon
 */
import { IconTenantedUnits } from "components/Icons/Dashboard"
/**
 * Styles
 */
import { toPercentage } from "utils/helpers"
import styles from "./styles"
/**
 * Hooks
 */
import { TotalTenantedUnitsHook, TotalUnitsHook } from "./hooks"
/**
 * Utils
 */

const TotalTenantedUnits = () => {
  const classes = styles()
  const { totalTenantedUnits, isValidating } = TotalTenantedUnitsHook()
  const { totalUnits } = TotalUnitsHook()
  const percentValue = `${toPercentage(totalTenantedUnits, totalUnits)}%`

  function ViewHeader(): JSX.Element {
    return (
      <Box className={classes.header}>
        <CardTitle title="Total Tenanted Units" icon={IconTenantedUnits} />
      </Box>
    )
  }

  function ViewInfo(): JSX.Element {
    return (
      <Box className={classes.info}>
        <Box className={classes.total}>{totalTenantedUnits}</Box>
        <Box>
          <Box className={classes.percentage}>{percentValue}</Box>
          <Box className={classes.body}>of total units</Box>
        </Box>
      </Box>
    )
  }

  function ViewHighlight(): JSX.Element {
    return (
      <Box className={classes.bar} margin="0 23px">
        <Box className={classes.barHighlight} width={percentValue} />
      </Box>
    )
  }

  function ViewTotalUnits(): JSX.Element {
    return (
      <Box className={classes.info}>
        <Box className={classes.body} />
        <Box className={classes.body}>{`Total Units: ${totalUnits}`}</Box>
      </Box>
    )
  }

  return (
    <Card>
      <ViewHeader />
      {isValidating ? (
        <Loader dark />
      ) : (
        <Fade in timeout={1000}>
          <Box>
            <ViewInfo />
            <ViewHighlight />
            <ViewTotalUnits />
          </Box>
        </Fade>
      )}
    </Card>
  )
}

export default TotalTenantedUnits
